import Vue, { CreateElement } from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import NotFound from '../components/NotFound.vue'
import { authGuard } from '@/guards/auth.guard'
import { recordPageInAnalytics } from 'vue-common'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    beforeEnter: authGuard
  },
  {
    path: '/companies',
    beforeEnter: authGuard,
    component: {
      render(createElem: CreateElement) {
        return createElem('router-view')
      }
    },
    children: [
      {
        path: ':companyId',
        name: 'Company',
        component: () => import(/* webpackChunkName: "company" */ '../views/Company.vue'),
        meta: {
          breadcrumbs: [
            {
              text: ':companyName',
              to: ''
            }
          ]
        }
      },
      {
        path: ':companyId/folders/:folderId',
        name: 'FolderDetails',
        component: () => import(/* webpackChunkName: "folder" */ '../views/Folder.vue'),
        meta: {
          breadcrumbs: [
            {
              text: ':companyName',
              to: '/companies/:companyId'
            },
            {
              text: ':folderName',
              to: ''
            }
          ]
        }
      },
      {
        path: ':companyId/folders/:folderId/techpack/:techpackId',
        name: 'InlineTechpack',
        component: () => import(/* webpackChunkName: "inline techpack" */ '../views/TechpackDetail.vue'),
        meta: {
          breadcrumbs: [
            {
              text: ':companyName',
              to: '/companies/:companyId'
            },
            {
              text: ':folderName',
              to: '/companies/:companyId/folders/:folderId'
            },
            {
              text: ':techpackName',
              to: ''
            }
          ]
        }
      }
    ]
  },
  {
    path: '/techpack/:techpackId',
    name: 'TechPack',
    component: () => import(/* webpackChunkName: "techpack" */ '../views/TechPackShare.vue')
  },
  {
    path: '*',
    name: '404',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * record page visit in segment
 */
router.afterEach(recordPageInAnalytics)

export default router
